export const userTypes = {
  ADMIN: 1,
  RECRUITER: 2,
  CANDIDATE: 3,
  REFERRAL_AMBASSADOR: 4,
  HIRING_COMPANY: 6,
};

export enum EnumUserTypes {
  ADMIN = 1,
  RECRUITER = 2,
  CANDIDATE = 3,
  REFERRAL_AMBASSADOR = 4,
  HIRING_COMPANY = 6,
}
export const RecruiterTypes = {
  ADMIN: 1,
  SUBADMIN: 2,
  MEMBER: 3,
};

export const RecruiterApprovalStatus = {
  REQUESTED: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

export enum HiringCompanyApprovalStatus {
  REQUESTED = 1,
  ACCEPTED,
  REJECTED,
}

export enum HiringCompanyType {
  ADMIN = 1,
  SUBADMIN,
  MEMBER,
}

export enum EnumJobTrackerStatus {
  APPLIED = "Applied",
  APPLICATIONVIEWED = "Application Viewed",
  INTERVIEWSCHEDULED = "Interview Scheduled",
  CANDIDATEPLACED = "Candidate Placed",  // for Recruiter Agency
  SHORTLIST = "Shortlist",
  DECLINE = "Decline",
  SUBMITOFFER = "Submit Offer",
  JOBCLOSE = "Job Close",
  SUBMIT_TO_HIRING_COMPANY = "Submit To Hiring Company",
  SEND_MEETING_INVITATION = "Send Meeting Invitation",            // for hiring company
  SHORTLIST_BY_HIRING_COMPANY = "Shortlisted by Hiring Company",  // for hiring company
  DECLINE_BY_HIRING_COMPANY = "Declined by Hiring Company",      // for hiring company
  JOB_REQUIREMENT_CLOSE = "Job Requirement Close",
  APPLICATION_VIEWED_BY_HIRING_COMPANY = "Application Viewed By Hiring Company", // for hiring company     
  INTERVIEW_MEETING_CLOSED = "Interview Meeting Closed",   // for meeting creator HC/RA
  OFFER_ACCEPTED = "Offer Accepted",         // for Candidate
  OFFER_DECLINED = "Offer Declined",      // for Candidate
  REQUEST_EXCLUSIVE_REPRESENTATION = "Request Exclusive Representation", // for recruiter 
  CANDIDATE_HAS_JOINED_HIRING_COMPANY = "Candidate Has Joined Hiring Company", // for Recruiter Release referral fees
}

export enum EnumActivityTracker {
  USER_REGISTERED = "UserRegistered", // when user is register
  PROFILE_UPDATED = "ProfileUpdated", // when user update it's profile details
  JOB_POSTED = "JobPosted",
  JOB_REQUIREMENT_POSTED = "JobRequirementPosted",
  APPLICATION_SUBMITTED = "ApplicationSubmitted", // tracker for candidate when recruiter submit candidate to hiring company
  CANDIDATE_SUBMITTED = "Candidate Submitted", // tracker for hiring company when recruiter agency submit candidate for specific job requirement
  APPLICATION_VIEWED = "ApplicationViewed", // tracker for candidate when recruiter agency view candidate profile
  INTERVIEW_INVITE_SENT = "InterviewInviteSent", // tracker for candidate when recruiter agency send meeting invitation for one slot
  CANDIDATE_APPLIED = "CandidateApplied", // tracker for recruiter agency as well as candidate user
  SHORTLIST_BY_RECRUITER_AGENCY = "ShortlistedByRecruiterAgency", // tracker for candidate when recruiter shortlist any candidate for specific job
  HIRING_COMPANY_ADDED = "HiringCompanyAdded",
  AVAILABILITY_POLL = "AvailabilityPollSent", // tracker for candidate when entity propose new poll
  INTERVIEW_CLOSED = "InterviewClosed",
  SHORTLIST_BY_HIRING_COMPANY = "ShortlistedByHiringCompany", // tracker(RA,Candidate) when hiring company shortlist a candidate for specific jobRequirement
  CANDIDATE_SHORTLISTED = "CandidateShortlisted", // tracker for HC self when shortlist any candidate
  SUBMIT_OFFER = "SubmitOffer", // tracker for HC and RA when hiring company submit offer to candidate
  OFFER_RECEIVED = "OfferReceived", // tracker for Candidate when HC submit offer for specific job requirement
  OFFER_ACCEPTED = "OfferAccepted", // tracker HC and RA when candidate is accepted submitted offer
  SUCCESSFUL_PLACEMENT = "SuccessfulPlacement", // Tracker for all entity when RA add candidate as successful placement
  MEETING_FORWARDED = "MeetingForwarded", // tracker for RA and candidate when meeting creator forwarded meeting to another user
  INTERVIEW_INVITATION = "InterviewInvitation", // tracker for RA when HC send meeting detail to RA
  JOB_MATCHES = "JobMatches", //  tracker for RA when job is match from HC submitted job requirement
  REFERRAL_FEES_PENDING = "ReferralFeesPending", // tracker for RA  when candidate get placed in any company for job position
  PENDING_PAYMENT = "PendingPayment", // tracker for Referral member  when candidate get placed by RA for specific job position
  PAYMENT_RECEIVED = "PaymentReceived", // tracker for Referral ,member when Recruiter pay Commission  fees
  REQUIREMENT_AGENT_ADDED = "RequirementAgentAdded", // tracker for HC when RA approve partner agency request
  JOB_REQUIREMENT_SUBMITTED = "JobRequirementSubmitted", // tracker for HC when they submit any job requirement to any Recruiter
  REQUIREMENT_POSTED = "RequirementPosted", // tracker for HC when RA create job post from submitted job requirement
  INTERVIEW_TIME_ACCEPTED = "InterviewTimeAccepted", // tracker for HC when candidate accept time for interview meeting
  CANDIDATE_INVITE_ACTION = "CandidateInviteAction", // tracker for referral Agent when candidate perform Invite Action
  APPLICATION_DECLINE_BY_RECRUITER_AGENCY = "ApplicationDeclineByRecruiterAgency", // tracker for, HC and candidate when RA decline any candidate Application
  APPLICATION_DECLINE = "ApplicationDecline", // tracker for RA and HC when they perform Decline Action
  APPLICATION_DECLINE_BY_HIRING_COMPANY = "ApplicationDeclineByHiringCompany", // tracker for RA and Candidate when HC Decline candidate application
  APPLICATION_WITHDRAW_BY_CANDIDATE = "ApplicationWithdrawByCandidate", // tracker for RA and HC when candidate is withdraw their application
  APPLICATION_WITHDRAW = "ApplicationWithdraw", // tracker for candidate when they withdraw job application
  NEW_JOB_NOTIFY_BY_REFERRAL = "NewJobMatchNotifyByReferral", // tracker for candidate when referral perform  match job notify action
  VIEWED_JOB_MATCH_BY_CANDIDATE = "ViewedJobMatchByCandidate", // tracker for referral User when candidate viewed unseen job matched
}

export const candidateStatus = {
  AVAILABLE: "Available",
  CONTRACTED: "Contracted",
  OPEN_TO_OPPORTUNITIES: "Open to opportunities",
  UNAVAILABLE: "Unavailable",
};

export enum JobRequirementCloseReason {
  NO_LONGER_REQUIRED = 1,
  JOB_REQUIREMENT_FULFILLED,
}

export type SkillsUsed = "Current" | "This Year" | "Last Year" | "2+ years";

export const skillsUsed: Record<SkillsUsed, number> = {
  Current: 1,
  "This Year": 2,
  "Last Year": 3,
  "2+ years": 4,
};

export const gender = [
  {
    label: "Male",
    value: 1,
  },
  {
    label: "Female",
    value: 2,
  },
  {
    label: "Others",
    value: 3,
  },
];

const levelSelect = [
  {
    label: "Beginner",
    value: 1,
  },
  {
    label: "Foundation",
    value: 2,
  },
  {
    label: "Intermediate",
    value: 3,
  },
  {
    label: "Expert",
    value: 4,
  },
  {
    label: "Elite",
    value: 5,
  },
];

const questionTypes = [
  {
    label: "Multiple Choice Question",
    value: "multiple-choice",
  },
  {
    label: "Check Box Question",
    value: "check-box",
  },
  {
    label: "Single Question/Answer",
    value: "single-answer",
  },
];

const sliderValues = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
  },
  {
    value: 2,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
  {
    value: 5,
  },
  {
    value: 6,
  },
  {
    value: 7,
  },
  {
    value: 8,
  },
  {
    value: 9,
  },
  {
    value: 9.7,
    label: "10",
  },
];

const skillsLastUsed = [
  {
    label: "Current",
    value: "current",
  },
  {
    label: "This Year",
    value: "thisYear",
  },
  {
    label: "Last Year",
    value: "lastYear",
  },
  {
    label: "2+ years ago",
    value: "2yearsAgo",
  },
];

enum PublishStatus {
  PUBLISH = 1,
  UNPUBLISH,
}

const EnumJobStatus = {
  DRAFT: 1,
  LIVE: 2,
  CLOSED: 3,
  FULFILLED: 4,
  UNPUBLISHED: 5,
  EXPIRED: 6,
};


const JobStatus = {
  DRAFT: 1,
  LIVE: 2,
  CLOSED: 3,
  FULFILLED: 4,
  UNPUBLISHED: 5,
  EXPIRED: 6,
};

const ContractType = {
  CONTRACT: 1,
  PARTTIME: 2,
  PERMANENT: 3,
};
const PositionLevel = {
  INTERN: 1,
  FRESHER: 2,
  JUNIOR: 3,
  ASSOCIATE: 4,
  MID: 5,
  SENIOR: 6,
  LEAD: 7,
  MANAGER: 8,
  SR_MANAGER: 9,
  DIRECTOR: 10,
  SR_DIRECTOR: 11,
  VP: 12,
  SVP: 13,
  EVP: 14,
  FOUNDER: 15,
};

// enum JobStatus {
//   DRAFT = 1,
//   LIVE,
//   CLOSED,
//   FULFILLED,
//   UNPUBLISHED,
//   EXPIRED
//   }

// const JobTypeEnum = {
//   FULLTIME: 1,
//   PARTTIME: 5,
//   REMOTE: 6,
//   CONTRACT: 2,
//   INTERNSHIP: 3,
//   CASUAL: 4,
//   HYBRID: 7,
// };

enum JobTypeEnum {
  FULLTIME = 1,
  CONTRACT,
  PARTTIME,
}

enum WorkPlaceOptionsEnum {
  ONSITE = 1,
  HYBRID,
  REMOTE,
}

const MatchedJobStatus = {
  Applied: 3,
  Interviewing: 4,
  Successful: 5,
};

const WorkPlaceOptions = [
  {
    label: "On-site",
    value: WorkPlaceOptionsEnum?.ONSITE,
  },
  {
    label: "Hybrid",
    value: WorkPlaceOptionsEnum?.HYBRID,
  },
  {
    label: "Remote",
    value: WorkPlaceOptionsEnum?.REMOTE,
  },
];

const JobType = [
  {
    label: "Full Time",
    value: JobTypeEnum?.FULLTIME,
  },
  {
    label: "Contract",
    value: JobTypeEnum?.CONTRACT,
  },
  // {
  //   label: "Internship",
  //   value: JobTypeEnum?.INTERNSHIP,
  // },
  // {
  //   label: "Casual",
  //   value: JobTypeEnum?.CASUAL,
  // },
  {
    label: "Part Time",
    value: JobTypeEnum?.PARTTIME,
  },
  // {
  //   label: "Remote",
  //   value: JobTypeEnum?.REMOTE,
  // },
  // {
  //   label: "Hybrid",
  //   value: JobTypeEnum?.HYBRID,
  // },
];

const JobSkills = [
  {
    label: "current",
    value: 1,
  },
  {
    label: "this year",
    value: 2,
  },
  {
    label: "last year",
    value: 3,
  },
  {
    label: "2+ years",
    value: 4,
  },
];

const datePostedType = [
  {
    label: "Last 24 Hours",
    value: 1,
  },
  {
    label: "Last 7 Days",
    value: 2,
  },
  {
    label: "Last 14 Days",
    value: 3,
  },
  {
    label: "Last 30 Days",
    value: 4,
  },
];

const CandidateAssessmentStatusEnum = {
  ASSESSMENT_RECEIVED: 1,
  ASSESSMENT_INPROGRESS: 2,
  ASSESSMENT_COMPLETED: 3,
};

const CandidateAssessmentStatus = [
  {
    label: "Assessment Received",
    value: CandidateAssessmentStatusEnum?.ASSESSMENT_RECEIVED,
  },
  {
    label: "Assessment InProgress",
    value: CandidateAssessmentStatusEnum?.ASSESSMENT_INPROGRESS,
  },
  {
    label: "Completed Assessment",
    value: CandidateAssessmentStatusEnum?.ASSESSMENT_COMPLETED,
  },
];

export const recruiterApprovalStatus = {
  ALL: 1,
  PENDING: 2,
  APPROVED: 3,
  // PENDING: 1,
  // APPROVED: 2,
  // REJECTED: 3,
};

export const AccountTypeSelect = [
  {
    label: "Checking",
    value: "checking",
  },
  {
    label: "Savings",
    value: "savings",
  },
];

export const PaymentHistoryStatus = {
  PROCESSING: "processing",
  SUCCEEDED: "succeeded",
  CANCELED: "canceled",
  REQUIRESPAYMENTMETHOD: "requires_payment_method",
  PENDING: "pending",
  REQUIRESACTION: "requires_action",
};

export const PaymentHistoryType = {
  SUCCEEDED: 1,
  PENDING: 2,
  FAILED: 3,
};

export {
  levelSelect,
  questionTypes,
  sliderValues,
  skillsLastUsed,
  WorkPlaceOptions,
  EnumJobStatus,
  JobStatus,
  PositionLevel,
  ContractType,
  JobType,
  MatchedJobStatus,
  JobTypeEnum,
  JobSkills,
  datePostedType,
  CandidateAssessmentStatus,
};
